import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./AboutSection.css";

// AboutSection component displays the "About Me" section
const AboutSection = ({ about }) => (
  <section id="about" className="about-section">
    <div className="about-container container">
      {/* Profile Image */}
      <div className="about-profile">
        <img
          src="/1774362756424.jpeg" 
          alt={`${about.hero} Profile`}
          className="profile-image"
        />
      </div>
      {/* Main welcome heading */}
      <h1 className="about-hero">{about.hero}</h1>
      {/* Subtitle */}
      <p className="about-subtitle">
        {about.subtitle}
      </p>
      {/* Social Links */}
      <div className="social-links">
        <a
          href="https://www.linkedin.com/in/jonah-tobies-0a783026b/"
          target="_blank"
          rel="noreferrer noopener"
          className="social-link linkedin"
          aria-label="LinkedIn Profile"
        >
          <FaLinkedin />
          <span>LinkedIn</span>
        </a>
        <a
          href="https://github.com/JonTob"
          target="_blank"
          rel="noreferrer noopener"
          className="social-link github"
          aria-label="GitHub Profile"
        >
          <FaGithub />
          <span>GitHub</span>
        </a>
      </div>
    </div>
  </section>
);

export default AboutSection;